import {
  Box,
  Grid,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CoreFileUploader from "../../core/inputs/CoreFileUploader";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_POST } from "../../config/constants";
import {
  SET_ADMIN_REDUCER,
  TESTING_ERROR,
  TESTING_SUCCESS,
} from "../../store/types/adminTypes";
import CoreTypographyBody1 from "../../core/dataDisplay/CoreTypographyBody1";
import { theme } from "../../config/theme";
import { downloadTestResult } from "../../store/actions/adminAction";
import CoreInput from "../../core/inputs/CoreInput";

export default function TestResults(props) {
  const dispatch = useDispatch(null);
  const testResult = useSelector((state) => state.admin.testResult);

  const [result, setResult] = useState(null);
  const [ground, setGround] = useState(null);
  const [docType, setDocType] = useState(null);
  const [uniqueField, setUniqueField] = useState("File name");

  const { data, errors } = testResult || {};

  useEffect(() => {
    if (testResult?.data) {
      let docTypes = Object.keys(testResult?.data);
      let key = docTypes[0];
      if (key) {
        setDocType(key);
      }
    }
  }, [testResult]);

  const handleUpload = (id, file) => {
    if (id === "result") {
      setResult(file);
    } else if (id === "ground") {
      setGround(file);
    }
  };

  const submitData = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/result/checking",
        {
          result,
          ground,
          uniqueField,
        },
        {},
        null,
        TESTING_SUCCESS,
        TESTING_ERROR,
        true,
        true,
      ),
    );
  };

  const handleExport = () => {
    dispatch(downloadTestResult({ data, errors }));
  };

  const onReset = () => {
    setResult(null);
    setGround(null);
    dispatch({ type: SET_ADMIN_REDUCER, payload: { testResult: null } });
  };

  const getTitle = (errors, docType, i, row, head) => {
    let err = errors[docType]?.find((err) => err.key === head && i === err.j);
    return err
      ? "Result: " + err.result + "\n" + "Actual: " + err.actual
      : row[head];
  };
  // console.log("testRes", testResult, docType);

  return (
    <div style={{ padding: 8 }}>
      <Box>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={5}>
            <CoreTypographyBody1>Result File</CoreTypographyBody1>
            <CoreFileUploader
              noImage={true}
              allowedFiles={["xlsx"]}
              noText={true}
              handleChange={(file) => {
                handleUpload("result", file);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <CoreTypographyBody1>Ground truth File</CoreTypographyBody1>
            <CoreFileUploader
              noImage={true}
              allowedFiles={["xlsx"]}
              noText={true}
              handleChange={(file) => {
                handleUpload("ground", file);
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={2}
            style={{
              alignItems: "center",
              flexDirection: "column",
              display: "flex",
            }}
          >
            <Box style={{ padding: 8 }}>
              <CoreInput
                label="Unique field"
                value={uniqueField}
                onChange={(e) => {
                  setUniqueField(e?.target?.value);
                }}
              />
            </Box>
            {/* <Box> */}
            <CoreContainedButton onClick={submitData}>
              Submit
            </CoreContainedButton>
            {data && (
              <>
                <CoreContainedButton
                  style={{ marginTop: 8 }}
                  disabled={!data}
                  onClick={handleExport}
                >
                  Export Result
                </CoreContainedButton>
                <CoreContainedButton
                  style={{ marginTop: 8 }}
                  disabled={!data}
                  onClick={onReset}
                >
                  Reset
                </CoreContainedButton>
              </>
            )}
            {/* </Box> */}
          </Grid>
        </Grid>
      </Box>
      {data && (
        <Box style={{ marginTop: 16 }}>
          <Tabs value={docType}>
            {Object.keys(data).map((type) => (
              <Tab
                label={type}
                value={type}
                style={{ marginLeft: 8 }}
                onClick={() => {
                  setDocType(type);
                }}
              />
            ))}
          </Tabs>
          <Grid container>
            <Grid item xs={12}>
              No of errors: {errors[docType]?.length}
            </Grid>
            <Grid item xs={12}>
              {docType && data[docType] && errors && (
                <TableContainer
                  style={{ maxHeight: "60vh", minHeight: "50vh" }}
                >
                  <Table>
                    <TableHead>
                      {Object.keys(data[docType][0])?.map((head) => (
                        <TableCell>
                          <div
                            style={{
                              maxWidth: "100px",
                              minWidth: "100px",
                              // height: 20,
                              // whiteSpace: "nowrap",
                              // textOverflow: "ellipsis",
                              // overflow: "hidden",
                            }}
                          >
                            {head}
                          </div>
                        </TableCell>
                      ))}
                    </TableHead>
                    <TableBody>
                      {data[docType].map((row, i) => (
                        <TableRow key={"row-" + i}>
                          {Object.keys(row)?.map((head, j) => (
                            <TableCell
                              key={"cell-" + i + "-" + j}
                              title={getTitle(errors, docType, i, row, head)}
                              style={
                                errors[docType]?.find(
                                  (err) => err.key === head && i === err.j,
                                )
                                  ? {
                                      backgroundColor:
                                        theme.palette.secondary.light,
                                      maxWidth: "100px",
                                      minWidth: "100px",
                                      height: 20,
                                      whiteSpace: "nowrap",
                                      textOverflow: "ellipsis",
                                      overflow: "hidden",
                                    }
                                  : {
                                      maxWidth: "100px",
                                      minWidth: "100px",
                                      height: 20,
                                      whiteSpace: "nowrap",
                                      textOverflow: "ellipsis",
                                      overflow: "hidden",
                                    }
                              }
                            >
                              {row[head]}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Grid>
          </Grid>
        </Box>
      )}
    </div>
  );
}
